import React from "react";
// import { useAuth } from "../context/AuthContext"; // Kept for future use
// import { useTheme } from "../context/ThemeContext"; // Kept for future use
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import DynamicSidebar from "../components/DynamicSidebar";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <div className="min-h-screen xl:flex">
      <div>
        {/* <Sidebar /> */}
        <DynamicSidebar />
        <Backdrop />
      </div>
      <div
        className={`flex-1 min-w-0 bg-[#F2EADB] transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[272px]" : "lg:ml-[76px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <AppHeader />
        <div className="mx-auto w-full min-w-0 max-w-screen-2xl md:p-3">
          <div
            className="rounded-2xl border min-h-[calc(100dvh-7rem)]"
            style={{
              background: "#F6F2E9",
              borderColor: "rgba(11,59,46,0.12)",
              boxShadow:
                "0 1px 2px rgba(11,59,46,0.04), 0 18px 40px -24px rgba(11,59,46,0.20)",
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const AppLayout: React.FC = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default AppLayout;
